import { render, staticRenderFns } from "./MarketField.vue?vue&type=template&id=7f1faff0&scoped=true"
import script from "./MarketField.vue?vue&type=script&lang=ts"
export * from "./MarketField.vue?vue&type=script&lang=ts"
import style0 from "./MarketField.vue?vue&type=style&index=0&id=7f1faff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1faff0",
  null
  
)

export default component.exports